<template>
    <div class="p-24 bg-primary-5 border border-primary-20 rounded mb-32">
        <label class="text-body flex items-center mb-12">
            <span class="first-letter:uppercase font-semibold">
                {{ $t('site_editor.languages.publish') }}
            </span>
        </label>
        <div class="grid grid-cols-4 gap-12">
            <toggle
                class="flex-none inline-block"
                :key="lang"
                :value="lang"
                v-for="lang in languages"
                v-model="form.published[lang]"
            >
                {{ $t('languages.' + lang + '.title') }}
            </toggle>
        </div>
    </div>
</template>

<script>
import Toggle from './Toggle.vue';
import { mapState } from 'pinia';
import {useMainStore} from '../../state/store';

export default {
    components: {
        'toggle': Toggle,
    },
    props: {
        form: {
            required: true,
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        languages () {
            return this.currentCompany.jobsite.active_languages;
        },
    }
}
</script>
